/* istanbul ignore file */
import { ExperienceTemplateRenderer, ExperienceTemplateRendererContextProvider } from 'experience-template-renderer-react';
import { inject, observer } from 'mobx-react';
import * as React from 'react';

import { Experiment, ExperimentControl, ExperimentVariant } from '@shared-ui/experiment-context';

import { PageLayoutStore } from 'stores/page-layout-store';

import { componentLibrary } from 'components/search/template-components';

interface TemplateRendererProps {
  pageLayout?: PageLayoutStore;
}
export const TemplateRenderer: React.FC<TemplateRendererProps> = inject('pageLayout')(
  observer(({ pageLayout }) => (
    <ExperienceTemplateRendererContextProvider library={componentLibrary}>
      <Experiment name="lodging_reconnect_travel_hackathon">
        <ExperimentControl>
          <ExperienceTemplateRenderer templateComponents={pageLayout.getSRPTemplate(pageLayout?.templateName)?.components} />
        </ExperimentControl>
        <ExperimentVariant bucket={1}>
          <ExperienceTemplateRenderer templateComponents={pageLayout.getCarouselSearchTemplate()?.components} />
        </ExperimentVariant>
      </Experiment>
    </ExperienceTemplateRendererContextProvider>
  ))
);
